<div class="main-content" [ngStyle]="{ direction: pageDirection }">
  <div class="flex flex-wrap lgw-5_6 xlw-11_12">
    <label class="t-label-top py-4">
      <input
        type="radio"
        name="Funding"
        class="custom-check"
        [(ngModel)]="view"
        (ngModelChange)="switchViewMode($event)"
        value="visits"
      />
      <i class="customInput-display"></i>
      <span style="font-size: large">
        {{ "appointments.gui.labels.self appointments" | translate }}
      </span>
    </label>

    <label class="t-label-top py-4">
      <input
        type="radio"
        name="Funding"
        class="custom-check"
        [(ngModel)]="view"
        (ngModelChange)="switchViewMode($event)"
        value="notConfirmed"
      />
      <i class="customInput-display"></i>
      <span style="font-size: large">
        {{ "appointments.gui.labels.Arrivals Not Approved by the Patients" | translate }}
      </span>
    </label>

    <label class="t-label-top py-4">
      <input
        type="radio"
        name="Funding"
        class="custom-check"
        [(ngModel)]="view"
        (ngModelChange)="switchViewMode($event)"
        value="messages"
      />
      <i class="customInput-display"></i>
      <span style="font-size: large">
        {{ "appointments.gui.labels.messages set by patients" | translate }}
      </span>
    </label>
  </div>
  <div class="m-box">
    <ng-container *ngIf="view == 'notConfirmed'">
      <div class="search-results">
        <div class="flex gap-4 items-center mb-4">
          <div>
            <strong style="margin-right: 0.5em">
              {{ "appointments.gui.labels.From" | translate }}:
            </strong>
            <input
              [matDatepicker]="fromPicker"
              [(ngModel)]="filterFromDate"
              class="t-field t-field--date menstural-field"
              (click)="fromPicker.open()"
              style="margin-right: 1em"
            />
            <mat-datepicker #fromPicker></mat-datepicker>
            <strong style="margin-right: 0.5em">
              {{ "appointments.gui.labels.Until" | translate }}:
            </strong>
            <input
              [matDatepicker]="toPicker"
              [(ngModel)]="filterToDate"
              (click)="toPicker.open()"
              class="t-field t-field--date menstural-field"
              style="margin-right: 1em"
            />
            <mat-datepicker #toPicker></mat-datepicker>
          </div>
          <div style="margin: 0 0.5em 0 0.5em; display: flex">
            <button
              [disabled]="!filterFromDate || !filterToDate"
              mat-button
              color="primary"
              class="blue-btn"
              (click)="applyDateFilter()"
            >
              {{ "appointments.gui.buttons.Filter" | translate }}
            </button>
            <button mat-button color="warn" class="orange-btn" (click)="clearDateFilter()">
              {{ "appointments.gui.buttons.Clear Filter" | translate }}
            </button>
            <button>
              <img
                style="cursor: pointer"
                [matTooltip]="'appointments.gui.tooltips.Download CVS' | translate"
                (click)="exportExcel()"
                height="31em"
                width="31em"
                src="../../assets/icons/fileblue.svg"
              />
            </button>
          </div>
        </div>

        <table *ngIf="filteredAppointments && filteredAppointments.length">
          <thead>
            <tr>
              <th>#</th>
              <th>
                {{ "appointments.gui.labels.creation time" | translate }}
                <button class="sort-btn" (click)="sortByCreationTimeAllAppts('asc')">▲</button>
                <button class="sort-btn" (click)="sortByCreationTimeAllAppts('desc')">▼</button>
              </th>
              <th>
                {{ "billing.gui.labels.Exam Name" | translate }}
              </th>
              <th>
                {{ "general.Patient.ID" | translate }}
              </th>
              <th>
                {{ "appointments.gui.labels.patient name" | translate | titlecase }}
              </th>
              <th>
                {{ "appointments.gui.labels.Mobile" | translate }}
              </th>
              <th *ngIf="!loginService?.premissions?.ApptsByRoom">
                {{ "appointments.gui.labels.Doctor" | translate }}
              </th>
              <th *ngIf="loginService?.premissions?.ApptsByRoom">
                {{ "appointments.gui.labels.room" | translate | titlecase }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let appointment of filteredAppointments | filterArrOfObjByVal : 'arrivalConfirm' : false;
                let i = index
              "
            >
              <td class="pointer" (click)="setPage(appointment)">
                {{ i + 1 }}
              </td>
              <td class="pointer" (click)="setPage(appointment)">
                {{ appointment.createdDate | date : "dd.MM.yyyy HH:mm" }}
              </td>
              <td class="pointer" (click)="setPage(appointment)">
                {{ appointment.isCustom ? appointment.examType : appointment.examName }}
              </td>
              <td class="pointer" (click)="setPage(appointment)">
                {{ appointment.ID }}
              </td>
              <td class="pointer" (click)="setPage(appointment)">
                {{ appointment.First }} {{ appointment.Last }}
              </td>
              <td class="pointer" (click)="setPage(appointment)">
                {{ appointment.Mobile }}
              </td>
              <td
                *ngIf="!loginService?.premissions?.ApptsByRoom"
                class="pointer"
                (click)="setPage(appointment)"
              >
                {{ appointment.docName }}
              </td>
              <td
                *ngIf="loginService?.premissions?.ApptsByRoom"
                class="pointer"
                (click)="setPage(appointment)"
              >
                {{ loginService.getRoomByRID(appointment.RID) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <ng-container *ngIf="view == 'visits'">
      <div class="search-results">
        <div class="flex gap-4 items-center mb-4">
          <div>
            <strong style="margin-right: 0.5em">
              {{ "appointments.gui.labels.From" | translate }}:
            </strong>
            <input
              [matDatepicker]="fromPickerV"
              [(ngModel)]="filterFromDate"
              class="t-field t-field--date menstural-field"
              (click)="fromPickerV.open()"
              style="margin-right: 1em"
            />
            <mat-datepicker #fromPickerV></mat-datepicker>
            <strong style="margin-right: 0.5em">
              {{ "appointments.gui.labels.Until" | translate }}:
            </strong>
            <input
              [matDatepicker]="toPickerV"
              [(ngModel)]="filterToDate"
              class="t-field t-field--date menstural-field"
              (click)="toPickerV.open()"
              style="margin-right: 1em"
            />
            <mat-datepicker #toPickerV></mat-datepicker>
          </div>
          <div style="margin: 0 0.5em 0 0.5em; display: flex">
            <button
              [disabled]="!filterFromDate || !filterToDate"
              mat-button
              color="primary"
              class="blue-btn"
              (click)="applyVisitsDateFilter()"
            >
              {{ "appointments.gui.buttons.Filter" | translate }}
            </button>
            <button mat-button color="warn" class="orange-btn" (click)="clearVisitsDateFilter()">
              {{ "appointments.gui.buttons.Clear Filter" | translate }}
            </button>
            <button>
              <img
                style="cursor: pointer"
                [matTooltip]="'appointments.gui.tooltips.Download CVS' | translate"
                (click)="exportExcel()"
                height="31em"
                width="31em"
                src="../../assets/icons/fileblue.svg"
              />
            </button>
          </div>
        </div>

        <table *ngIf="appointments && appointments.length">
          <thead>
            <tr>
              <th>#</th>
              <th>
                {{ "appointments.gui.labels.creation time" | translate }}
                <button class="sort-btn" (click)="sortByCreationTime('asc')">▲</button>
                <button class="sort-btn" (click)="sortByCreationTime('desc')">▼</button>
              </th>
              <th>
                {{ "billing.gui.labels.Exam Name" | translate }}
              </th>
              <th>
                {{ "general.Patient.ID" | translate }}
              </th>
              <th>
                {{ "appointments.gui.labels.patient name" | translate | titlecase }}
              </th>
              <th>
                {{ "appointments.gui.labels.Mobile" | translate }}
              </th>
              <th *ngIf="!loginService?.premissions?.ApptsByRoom">
                {{ "appointments.gui.labels.Doctor" | translate }}
              </th>
              <th *ngIf="loginService?.premissions?.ApptsByRoom">
                {{ "appointments.gui.labels.room" | translate | titlecase }}
              </th>
              <th>
                {{ "appointments.gui.labels.status" | translate }}
                <button class="sort-btn" (click)="sortByStatus('asc')">▲</button>
                <button class="sort-btn" (click)="sortByStatus('desc')">▼</button>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let appointment of filteredVisits; let i = index">
              <td class="pointer" (click)="setPage(appointment)">{{ i + 1 }}</td>
              <td class="pointer" (click)="setPage(appointment)">
                {{ appointment.createdDate | date : "dd.MM.yyyy HH:mm" }}
              </td>
              <td class="pointer" (click)="setPage(appointment)">
                {{ appointment.isCustom ? appointment.examType : appointment.examName }}
              </td>
              <td class="pointer" (click)="setPage(appointment)">{{ appointment.ID }}</td>
              <td class="pointer" (click)="setPage(appointment)">
                {{ appointment.First }} {{ appointment.Last }}
              </td>
              <td class="pointer" (click)="setPage(appointment)">{{ appointment.Mobile }}</td>
              <td
                *ngIf="!loginService?.premissions?.ApptsByRoom"
                class="pointer"
                (click)="setPage(appointment)"
              >
                {{ appointment.docName }}
              </td>
              <td
                *ngIf="loginService?.premissions?.ApptsByRoom"
                class="pointer"
                (click)="setPage(appointment)"
              >
                {{ loginService.getRoomByRID(appointment.RID) }}
              </td>
              <td>
                <select
                  class="t-select w100"
                  [(ngModel)]="appointment.Status"
                  (change)="onStatusChange(appointment)"
                >
                  <option value="waiting">
                    {{ "appointments.gui.labels.Status.Waiting" | translate }}
                  </option>
                  <!-- <option value="pending">{{'appointments.gui.labels.Status.Pending' | translate}}</option> -->
                  <option value="approved">
                    {{ "appointments.gui.labels.Status.Approved" | translate }}
                  </option>
                </select>
              </td>
              <td>
                <img
                  src="../../assets/icons/delete-blue.svg"
                  matTooltip="delete from list"
                  (click)="changeStatus('resolved', appointment.AutoIndex)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <app-leads *ngIf="view == 'messages'" mode="messages"></app-leads>
  </div>
</div>
